/**
 * Converte um arquivo .docx (Word) para HTML preservando formatacao basica.
 * `mammoth` eh code-split via dynamic import — so carrega quando o usuario clica em Subir.
 */

export interface DocxConversionResult {
  html: string;
  messages: string[]; // warnings de conversao (imagens perdidas, estilos nao suportados, etc.)
}

export async function docxToHtml(file: File): Promise<DocxConversionResult> {
  if (!file.name.toLowerCase().endsWith(".docx")) {
    throw new Error("O arquivo precisa ser um .docx (Word). Salve o documento como .docx e tente de novo.");
  }
  if (file.size > 5 * 1024 * 1024) {
    throw new Error("Arquivo muito grande. O limite eh 5 MB.");
  }

  const arrayBuffer = await file.arrayBuffer();
  const mammoth = await import("mammoth");
  const result = await mammoth.convertToHtml({ arrayBuffer });

  const cleanHtml = wrapWithDefaultStyle(result.value);
  const messages = (result.messages ?? []).map((m) => m.message);

  return { html: cleanHtml, messages };
}

/**
 * mammoth devolve o corpo do <body> sem estilo — envelopamos com um div que da
 * fonte/tamanho consistente com o preview e com o PDF final.
 */
function wrapWithDefaultStyle(inner: string): string {
  return `<div style="font-family: Arial, sans-serif; font-size: 11pt; line-height: 1.6; text-align: justify; padding: 20px;">
${inner}
</div>`;
}
